"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@components/Button"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var psl_1 = __importDefault(require("psl"));
var react_hook_form_1 = require("react-hook-form");
var clickOutsideHook_1 = require("@common/hooks/clickOutsideHook");
var linkUtils_1 = require("@utils/linkUtils");
var _store_1 = require("@store");
var notifier_1 = __importDefault(require("@utils/notifier"));
var trustedDomain_1 = require("@common/services/trustedDomain");
var trustedDomainsSlice_1 = require("../../state/trustedDomainsSlice");
function Security(props) {
    var _this = this;
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)(['settings', 'common']).t;
    var domain = props.domain;
    var _c = __read((0, react_1.useState)([]), 2), trustedDomainsState = _c[0], setTrustedDomainsState = _c[1];
    var _d = __read((0, react_1.useState)(''), 2), selectedDomain = _d[0], setSelectedDomain = _d[1];
    var dispatch = (0, _store_1.useAppDispatch)();
    var parentRef = (0, react_1.useRef)(null);
    var _e = (0, trustedDomain_1.useGetTrustedDomainQuery)(domain), trustedDomains = _e.data, isLoading = _e.isLoading, isError = _e.isError, refetch = _e.refetch;
    (0, clickOutsideHook_1.useClickOutside)(parentRef, function () { return setSelectedDomain(''); });
    var _f = (0, react_hook_form_1.useForm)(), register = _f.register, handleSubmit = _f.handleSubmit, errors = _f.formState.errors, reset = _f.reset, getValues = _f.getValues;
    var validateDomain = function (domainValue) {
        var hostname = (0, linkUtils_1.extractHostnameFromLink)(domainValue);
        var extractedDomain = (0, linkUtils_1.extractDomain)(domainValue);
        var parsedHostname = psl_1.default.parse(hostname);
        if (!extractedDomain || parsedHostname.error) {
            return t('settings:SECURITY.FORM_INVALID_DOMAIN');
        }
        var tld = parsedHostname.tld;
        if (!(0, linkUtils_1.hasValidTLD)(hostname)) {
            return t('settings:SECURITY.TLD_IS_INVALID', { tld: tld || '' });
        }
        return undefined; // Return undefined when validation passes
    };
    var onSubmit = function (data) {
        var extractedDomain = (0, linkUtils_1.extractDomain)(data.domain);
        var isDomainAlreadyExist = trustedDomainsState.find(function (domain) { return domain === extractedDomain; });
        if (isDomainAlreadyExist) {
            notifier_1.default.error(t('settings:SECURITY.DOMAIN_ALREADY_EXISTS', { domain: extractedDomain }));
            return;
        }
        reset(__assign(__assign({}, getValues()), { domain: '' }));
        setTrustedDomainsState(__spreadArray([extractedDomain], __read(trustedDomainsState), false));
    };
    var handleRemoveDomain = function () {
        setTrustedDomainsState(function (oldDomains) {
            return oldDomains.filter(function (domain) { return domain !== selectedDomain; });
        });
        setSelectedDomain('');
    };
    (0, react_1.useEffect)(function () {
        if (trustedDomains) {
            setTrustedDomainsState(trustedDomains);
        }
    }, [trustedDomains]);
    var saveChanges = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, trustedDomainsSlice_1.persistTrustedDomains)(domain, trustedDomainsState)).then(function () {
                refetch();
            });
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "moderation-settings" },
            react_1.default.createElement("form", null,
                react_1.default.createElement("div", { className: "setting__title" }, t('settings:SECURITY.TITLE')),
                react_1.default.createElement("div", { className: "moderation-settings__section" },
                    react_1.default.createElement("div", { className: "moderation-setting__section__title" }, t('settings:SECURITY.TRUSTED_DOMAINS')),
                    react_1.default.createElement("p", null, t('settings:SECURITY.DESCRIPTION')),
                    react_1.default.createElement("div", { className: "create-invite__content" },
                        react_1.default.createElement("input", __assign({ className: (0, clsx_1.default)('create-invite__input', errors.domain && 'eva-input--invalid'), placeholder: (_a = t('settings:SECURITY.DOMAIN_PLACEHOLDER')) !== null && _a !== void 0 ? _a : '' }, register('domain', { required: true, validate: validateDomain }))),
                        react_1.default.createElement(Button_1.default, { text: t('settings:SECURITY.ADD'), className: "add-domain-btn", onClick: handleSubmit(onSubmit), type: "submit" })),
                    react_1.default.createElement("div", { className: "create-invite__input-error" }, (_b = errors.domain) === null || _b === void 0 ? void 0 : _b.message)),
                react_1.default.createElement("div", { className: "domains-list-container", ref: parentRef },
                    react_1.default.createElement("div", { className: "domains-list" }, trustedDomainsState.map(function (domain, index) { return (react_1.default.createElement("div", { key: index, onClick: function () { return setSelectedDomain(domain); }, className: (0, clsx_1.default)('domain', selectedDomain === domain && 'selected-domain') }, domain)); })),
                    react_1.default.createElement(Button_1.default, { disabled: selectedDomain.length === 0, text: t('settings:SECURITY.REMOVE'), onClick: handleRemoveDomain, className: "add-domain-btn" })),
                react_1.default.createElement(Button_1.default, { text: t('common:COMMON.SAVE_CHANGES_BUTTON'), className: "save-changes-btn", onClick: saveChanges, disabled: isLoading || isError })))));
}
exports.default = Security;
